import { put, call } from 'redux-saga/effects';
import { subSectorList, subSectorAllList,subSectorAdd, subSectorEdit, subSectorUpdate, subSectorDelete } from '../../../services/settings/superadmin/subSectorService';

import * as types from '../../../actions';

export function* subSectorListSaga(payload) {
    try {
      const response = yield call(subSectorList, payload);
      yield put({ type: types.SUBSECTOR_LIST_SUPERADMIN_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.SUBSECTOR_LIST_SUPERADMIN_ERROR, error });
    }
}

export function* subSectorAllListSaga(payload) {
  try {
    const response = yield call(subSectorAllList, payload);
    yield put({ type: types.SUBSECTOR_ALL_LIST_SUPERADMIN_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SUBSECTOR_ALL_LIST_SUPERADMIN_ERROR, error });
  }
}

export function* subSectorAddSaga(payload) {
    try {
      const response = yield call(subSectorAdd, payload);
      yield put({ type: types.SUBSECTOR_ADD_SUPERADMIN_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.SUBSECTOR_ADD_SUPERADMIN_ERROR, error });
    }
}

export function* subSectorEditSaga(payload) {
  try {
    const response = yield call(subSectorEdit, payload);
    yield put({ type: types.SUBSECTOR_EDIT_SUPERADMIN_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SUBSECTOR_EDIT_SUPERADMIN_ERROR, error });
  }
}

export function* subSectorUpdateSaga(payload) {
  try {
    const response = yield call(subSectorUpdate, payload);
    yield put({ type: types.SUBSECTOR_UPDATE_SUPERADMIN_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SUBSECTOR_UPDATE_SUPERADMIN_ERROR, error });
  }
}

export function* subSectorDeleteSaga(payload) {
  try {
    const response = yield call(subSectorDelete, payload);
    yield put({ type: types.SUBSECTOR_DELETE_SUPERADMIN_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.SUBSECTOR_DELETE_SUPERADMIN_ERROR, error });
  }
}